var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"16","height":"16","fill":"currentColor","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"d":"M13.707,6.707L23,16l-9.293,9.293C13.077,25.923,12,25.477,12,24.586V7.414C12,6.523,13.077,6.077,13.707,6.707z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }